import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SmoothScroll from "./SmoothScroll";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteLayout = () => (
  <SmoothScroll>
    <ScrollToTop />
    <Navbar />
    <main className="bg-[#050505] min-h-screen">
      <Outlet />
    </main>
    <Footer />
  </SmoothScroll>
);

export default SiteLayout;
